import { monthToNumber } from './constants'

const dedupe = array => Array.from(new Set(array))

const getStopsText = numStops => {
  if (typeof numStops === 'number') {
    return numStops === 0
      ? 'Nonstop'
      : `${numStops} Stop${numStops > 1 ? 's' : ''}`
  }
  return '\xa0'
}

const getPriceText = (flexDatePriceExists, currencySymbol, flexDatePrice) =>
  flexDatePriceExists ? `${currencySymbol}${flexDatePrice}` : '\u2014'

const getSortedPrices = flexDates =>
  dedupe(
    flexDates.map(flexDate => flexDate.flexDatePrice).sort((a, b) => a - b)
  ).filter(item => item !== undefined)

const getHighlightColor = (price, sortedPrices) => {
  switch (sortedPrices.length) {
    case 1:
      return undefined
    case 2:
      return price === sortedPrices[0] ? 'highlight.light' : 'notify.light'
    default:
      return price === sortedPrices[0]
        ? 'highlight.light'
        : price === sortedPrices[sortedPrices.length - 1]
        ? 'warning.light'
        : 'notify.light'
  }
}

const getFormattedDate = flexDate => {
  const [dayOfWeek, month, day] = flexDate.split(' ')
  return `${dayOfWeek} ${monthToNumber[month]}/${day}`
}

const getFormattedFlexDates = (flexDates, sortedPrices) =>
  flexDates.map(date => {
    const {
      flexDatePriceExists,
      currencySymbol,
      flexDatePrice,
      numStops,
      isOriginalDepartDate,
      flexDate,
    } = date

    return {
      flexDate: getFormattedDate(flexDate),
      priceText: getPriceText(
        flexDatePriceExists,
        currencySymbol,
        flexDatePrice
      ),
      stopsText: getStopsText(numStops),
      priceHighlightColor: flexDatePriceExists
        ? getHighlightColor(flexDatePrice, sortedPrices)
        : undefined,
      isOriginalDepartDate,
      description:
        sortedPrices.length > 1 && flexDatePrice === sortedPrices[0]
          ? 'Cheapest!'
          : undefined,
      descriptionColor: isOriginalDepartDate ? 'text.lightest' : undefined,
    }
  })

const getFlexDatesTrackingPayload = ({
  flexDates,
  minPrice,
  maxPrice,
  searchDestination,
  selectedIndex,
}) => {
  return flexDates
    .filter(
      flexDatesItem =>
        flexDatesItem &&
        Object.keys(flexDatesItem).length > 0 &&
        !flexDatesItem.isOriginalDepartDate
    )
    .filter((flexDatesItem, index) =>
      selectedIndex === undefined ? true : index === selectedIndex
    )
    .map((i, index) => {
      const isCheapest = i.hasLowestPrice
      const numStops = i.numStops === 0 ? 'nonstop' : 'stops'
      const noOfDays = Math.abs(i.flexDateDaysDiff)
      const plusOrMinus = i.flexDateDaysDiff > 0 ? 'plus' : 'minus'
      const colorMap = {
        green: i.flexDatePrice === minPrice,
        red: i.flexDatePrice === maxPrice,
        yellow: i.flexDatePrice > minPrice && i.flexDatePrice < maxPrice,
      }
      const color = Object.keys(colorMap).find(key => colorMap[key]) || 'gray'
      const colorOrLabel = isCheapest ? 'cheapest' : color
      return {
        item_list_id: 'retail',
        item_list_name: 'flex_dates',
        item_id: `${plusOrMinus}_${noOfDays}_${colorOrLabel}_${numStops}`,
        item_name: 'air_' + searchDestination?.toLowerCase(),
        index,
      }
    })
}
export { getFormattedFlexDates, getSortedPrices, getFlexDatesTrackingPayload }
